import { CouldNotParse } from 'components/ordering/checkout/payment-methods/payment-backend/could-not-parse.js'
import { is } from 'typia'
import { CSCMollieKlarna, type TrydentMollieKlarnaData } from './mollie-klarna.js'
import { type KlarnaMethodId } from 'components/ordering/checkout/payment-methods/methods/method-ids.js'


type TrydentMollieKlarnaResponse = {
  custom_description: string,
  mollie_data: TrydentMollieKlarnaData & { id: KlarnaMethodId }
}

export const parseMollieKlarna = (value: unknown, selectedPaymentMethod: string): CSCMollieKlarna | typeof CouldNotParse => {
  if (is<TrydentMollieKlarnaResponse>(value)) {
    const state = value.mollie_data.id === selectedPaymentMethod ? 'selected' : 'selectable'
    return new CSCMollieKlarna(
      value.mollie_data,
      state,
      value.custom_description,
    )
  }
  return CouldNotParse
}
